/**
 * Counts Unicode code points (not UTF-16 code units) so the limit aligns with
 * backend `len([]rune(...))` counts.
 */
export const codePointLength = (value: string): number =>
  Array.from(value).length

/**
 * Truncates a string to the given maximum code-point length.
 */
export const truncateToCodePointLength = (
  value: string,
  max: number,
): string =>
  codePointLength(value) <= max
    ? value
    : Array.from(value).slice(0, max).join('')
